import React from 'react';
import LogoutButton from '../buttons/LogoutButton';
import { Link } from 'react-router-dom';

class TopBarReunionPhotos extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='top-bar'>
                <div>
                    <Link to={`/reunion/${this.props.year}`}>Back to Main Reunion Page</Link>
                </div>
                <div>
                    <LogoutButton />
                </div>
            </div>
        );
    }
}

export default TopBarReunionPhotos;
